import { observable, makeObservable } from 'mobx';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { Payload } from '../Payload';

export class CallPayload extends Payload {
  startInitiatorId;
  startTs;
  @observable duration;
  @observable reason;
  @observable finishReason;
  startInitiatorNickName;
  @observable finishInitiatorNickname;
  @observable finishInitiatorId;
  @observable finishTs;

  constructor(data) {
    super(data);

    makeObservable(this);

    this.startInitiatorId = data.initiatorId || data.initiator;
    this.callerId = data.callerId;
    this.startTs = data.startTs;
    this.duration = Number(data.duration);
    this.reason = data.reason;
    this.finishReason = data.finishReason;
    this.startInitiatorNickName = data.initiatorNickName;
    this.finishInitiatorNickname = data.finishInitiatorNickname;
    this.finishInitiatorId = data.finishInitiator && data.finishInitiator.toString();
    this.finishTs = data.finishTs;
  }

  get isSystem() {
    return true;
  }

  get isCall() {
    return true;
  }

  get isFinishCall() {
    if (this.payloadType === PayloadType.Call) {
      return true;
    }
    return Boolean(this.finishTs);
  }

  get initiatorNickName() {
    if (this.payloadType === PayloadType.Call) {
      return this.startInitiatorNickName;
    }
    if (this.isFinishCall) {
      return this.finishInitiatorNickname;
    }
    return this.startInitiatorNickName;
  }

  get initiatorId() {
    if (this.payloadType === PayloadType.Call) {
      return this.startInitiatorId;
    }
    if (this.isFinishCall) {
      return this.finishInitiatorId;
    }
    return this.startInitiatorId;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      startInitiatorId: this.startInitiatorId,
      callerId: this.callerId,
      startTs: this.startTs,
      duration: this.duration,
      reason: this.reason,
      finishReason: this.finishReason,
      startInitiatorNickName: this.startInitiatorNickName,
      finishInitiatorNickname: this.finishInitiatorNickname,
      finishInitiatorId: this.finishInitiatorId,
      finishTs: this.finishTs,
    };
  }
}
